import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from './utils';

/**
 * Kbd — inline display for a keyboard shortcut key, e.g. <Kbd>Ctrl</Kbd>+<Kbd>K</Kbd>.
 * Renders a semantic <kbd> element with a muted, boxed style.
 */
export const Kbd = forwardRef<HTMLElement, HTMLAttributes<HTMLElement>>(
  ({ className, children, ...props }, ref) => (
    <kbd
      ref={ref}
      className={cn(
        'inline-flex h-5 min-w-[1.25rem] select-none items-center justify-center rounded border border-border bg-muted px-1.5 font-mono text-[10px] font-medium text-muted-foreground shadow-sm',
        className,
      )}
      {...props}
    >
      {children}
    </kbd>
  ),
);
Kbd.displayName = 'Kbd';
